export default {
  tabs: {
    access: 'Acesso',
    notification_preferences: 'Preferências de notificação',
  },
  sections: {
    notification_preferences: {
      title: 'Preferências de notificação',
      form: {
        has_voice_call_reminders: {
          label: 'Receber chamadas automáticas sobre pedidos pendentes',
        },
        voice_reminders_phone_number: {
          label: 'Número de telefone para receber chamadas',
        },
        has_whatsapp_notifications: {
          label: 'Enviar notificações (ex. pedidos pausados) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Número de telefone do WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Enviar notificações de pedidos por email',
        },
        order_notifications_email: {
          label: 'Endereço de email para reencaminhar notificações de pedidos',
        },
      },
    },
    voice_calls: {
      title: 'Chamadas de voz',
    },
    whats_app_notifications: {
      title: 'Notificações WhatsApp',
    },
    order_email_notifications: {
      title: 'Notificações de pedidos por email',
    },
    access_control: {
      title: 'Controlo de acesso',
      form: {
        company_ids: {
          label: 'Pode aceder a restaurantes',
          tooltip: 'Dá acesso aos seguintes restaurantes (além dos restaurantes na mesma marca)',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
